@let _ = handleCaregiverChange$ | async;
<!-- used that sort of solution couse if we use only @let without using it angular throw warnings -->
@if (_) {
    <div class="o-grid__row">
        <div class="flex basis-full flex-col gap-2">
            <label class="caregiver-label">
                Which patient caregiver(s) will be attending the visit?
                <span class="required-asterisk">*</span>
            </label>
            <div id="accompanyingCaregivers" class="flex flex-col gap-medpace">
                @if (mode() === 'edit') {
                    <medpace-caregiver-checkbox-option-edit
                        [formGroup]="formGroup().controls.primaryCaregiver"
                        [isPrimary]="true"
                    />
                    @for (
                        caregiverFormGroup of formGroup().controls.otherCaregivers.controls;
                        track caregiverFormGroup
                    ) {
                        <medpace-caregiver-checkbox-option-edit [formGroup]="caregiverFormGroup" />
                    }
                } @else if (mode() === 'view') {
                    <medpace-caregiver-checkbox-option-view
                        [formGroup]="formGroup().controls.primaryCaregiver"
                        [isPrimary]="true"
                        (bookViaGetThereForCaregiver)="bookViaGetThereForCaregiver.emit($event)"
                    />
                    @for (
                        caregiverFormGroup of formGroup().controls.otherCaregivers.controls;
                        track caregiverFormGroup
                    ) {
                        <medpace-caregiver-checkbox-option-view [formGroup]="caregiverFormGroup" />
                    }
                }
                <mds-checkbox
                    [label]="'No caregivers will accompany patient'"
                    [formCtrl]="formGroup().controls.none.controls.checked"
                    [id]="'accompanyingCaregivers_None_Checkbox'"
                />
            </div>
            @for (error of formGroup().errors | keyvalue; track error.key) {
                <medpace-alert
                    [appearance]="'danger'"
                    [content]="error.value"
                    [attr.data-cy]="'accompanyingCaregiversAlert'"
                />
            }
        </div>
    </div>
}
